import { createAction } from 'redux-actions';

import types from './types';

const getNavigationCategoryTags = createAction(types.GET_NAVIGATION_CATEGORY_TAGS);
const setNavigationCategoryTags = createAction(types.SET_NAVIGATION_CATEGORY_TAGS);
const clearNavigationCategoryTags = createAction(types.CLEAR_NAVIGATION_CATEGORY_TAGS);
const setNavigationCategoryEndpoint = createAction(types.SET_NAVIGATION_CATEGORY_ENDPOINT);
const fetchRelatedKeywords = createAction(types.FETCH_RELATED_KEYWORDS);
const setRelatedKeywords = createAction(types.SET_RELATED_KEYWORDS);
const getCategoryPageTags = createAction(types.GET_CATEGORY_PAGE_TAGS);
const getProductList = createAction(types.GET_PRODUCT_LIST);
const setProductsList = createAction(types.SET_PRODUCT_LIST);
const setCurrentPage = createAction(types.SET_CURRENT_PAGE);
const getInterestSelectionPopupContent = createAction(types.GET_INTEREST_SELECTION_POPUP_CONTENT);
const setInterestSelectionComponents = createAction(types.SET_INTEREST_SELECTION_COMPONENTS);
const setInterestSelectionComponentData = createAction(types.SET_INTEREST_SELECTION_COMPONENT_DATA);
const setInterestSelectionKeywords = createAction(types.SET_INTEREST_SELECTION_KEYWORDS);
const interestSelectionStepSubmit = createAction(types.INTEREST_SELECTION_STEP_SUBMIT);

export default {
    getNavigationCategoryTags,
    setNavigationCategoryTags,
    setNavigationCategoryEndpoint,
    clearNavigationCategoryTags,
    fetchRelatedKeywords,
    setRelatedKeywords,
    getProductList,
    setProductsList,
    getCategoryPageTags,
    setCurrentPage,
    getInterestSelectionPopupContent,
    setInterestSelectionComponents,
    setInterestSelectionComponentData,
    setInterestSelectionKeywords,
    interestSelectionStepSubmit,
};
